import { service } from '@ember/service'
import Component from '@glimmer/component'
import type PromoService from 'teacher-ui-client/services/promo'
import {
  InlineAlert,
  AlertType,
  InlineAlertTitle,
  InlineAlertSubtitle,
} from 'teacher-ui-client/components/inline-alert'
import { LinkTo } from '@ember/routing'
import { t } from 'ember-intl'

interface Signature {
  Args: {
    isSubco: boolean
  }
}

/**
 * Readings Eggs CrossSell component, to show on maths home page to notify users of free Reading Eggs access
 **/

export class ReFreeAccessCrossSell extends Component<Signature> {
  @service promo!: PromoService

  <template>
    {{! template-lint-disable no-bare-strings }}
    {{#if this.promo.shouldShowReCrossSell}}
      <InlineAlert @type={{AlertType.Information}}>
        <InlineAlertTitle>
          {{t "promo.crossSell.re.intro"}}</InlineAlertTitle>
        <InlineAlertSubtitle>
          <div class="space-y-2">
            <div>
              {{t "promo.crossSell.re.about"}}
            </div>
            {{#if @isSubco}}
              <div>
                Your teachers can get started with Reading Eggs by
                <LinkTo @route="manage.classes" @model="reading"> setting up a class.</LinkTo>
                As the subscription coordinator, you can
                <LinkTo @route="subscription-type.copy-classes" @model="reading">
                  copy over your school’s math classes
                </LinkTo>
                to help your teachers get started today.
              </div>
            {{else}}
              <div>
                Get started with Reading Eggs by
                <LinkTo @route="manage.classes" @model="reading"> setting up a class.</LinkTo>
                You can
                <LinkTo @route="subscription-type.copy-classes" @model="reading">
                  copy over your math class
                </LinkTo>
                if you have one.
              </div>
            {{/if}}
          </div>
        </InlineAlertSubtitle>
      </InlineAlert>
    {{/if}}
  </template>
}

export default ReFreeAccessCrossSell
